import { getContext, setContext } from 'svelte';
import { DEFAULT_VALIDATION_I18N, type ValidationI18n } from './validation-i18n.js';

const VALIDATION_I18N_KEY = Symbol.for('@validation-i18n');

export function setValidationI18n(i18n: ValidationI18n): void {
	setContext(VALIDATION_I18N_KEY, i18n);
}

export function getValidationI18n(): ValidationI18n {
	return getContext<ValidationI18n>(VALIDATION_I18N_KEY) ?? DEFAULT_VALIDATION_I18N;
}
